<div class="col-span-12 mt-2">
  <!-- Kopfzeile: optionale Überschrift + Hinzufügen-Button -->
  <div
    class="flex items-center mb-2"
    [class.justify-between]="headline"
    [class.justify-center]="!headline"
  >
    @if (headline) {
      <h3 class="m-0">{{ headline }}</h3>
    }
    <p-button
      icon="pi pi-plus"
      [text]="!!headline"
      label="{{ 'animalAdd.origin.contacts.add' | transloco: { default: 'Kontakt hinzufügen' } }}"
      (click)="add.emit()"
    />
  </div>

  @if (contacts.length === 0) {
    @if (showEmptyState) {
      <div class="text-sm text-gray-500">
        {{ 'animalAdd.origin.contacts.empty' | transloco: { default: 'Noch keine Kontakte hinzugefügt.' } }}
      </div>
    }
  } @else {
    <p-accordion
      [multiple]="multiple"
      [value]="multiple ? [] : activePanel"
      (valueChange)="!multiple && activePanelChange.emit($any($event))"
    >
      @for (vm of contacts; track trackByContact($index, vm); let i = $index) {
        <p-accordion-panel [value]="i.toString()">
          <p-accordion-header>
            <div class="flex items-center justify-between w-full">
              <div class="flex items-center gap-2">
                <strong>{{ getTypeLabel(vm.ref.type) }}</strong>
                @if (showPrimaryBadge && vm.ref.isPrimary) {
                  <span class="text-xs px-2 py-0.5 rounded bg-blue-100 text-blue-700">
                    Primary
                  </span>
                }
                @if (vm.isValid === false) {
                  <span class="pi pi-exclamation-triangle text-red-400"></span>
                }
              </div>

              <p-button
                class="pr-1"
                icon="pi pi-trash"
                severity="danger"
                [rounded]="true"
                (click)="$event.stopPropagation(); remove.emit(i)"
              />
            </div>
          </p-accordion-header>

          <p-accordion-content>
            <div class="grid grid-cols-12 gap-2 mb-3">
              <div class="col-span-12 md:col-span-5">
                <p-iftalabel>
                  <p-select
                    class="w-full"
                    [options]="typeOptions"
                    optionLabel="label"
                    optionValue="value"
                    [ngModel]="vm.ref.type"
                    [ngModelOptions]="{ standalone: true }"
                    (onChange)="typeChanged.emit({ index: i, type: $event.value })"
                    appendTo="body"
                  ></p-select>
                  <label>Typ</label>
                </p-iftalabel>
              </div>

              <div class="col-span-12 md:col-span-4">
                <p-iftalabel>
                  <input
                    pInputText
                    type="text"
                    class="w-full"
                    [ngModel]="vm.ref.label"
                    [ngModelOptions]="{ standalone: true }"
                    (input)="labelChanged.emit({ index: i, label: $any($event.target).value })"
                  />
                  <label>Label (optional)</label>
                </p-iftalabel>
              </div>
            </div>

            <app-choose-contact
              [newContact]="vm.contact"
              [isExistingContact]="vm.isExisting"
              (newContactUpdated)="newContactUpdated.emit({ index: i, contact: $event })"
              (validationStatusChanged)="validationChanged.emit({ index: i, valid: $event })"
              (existingContactSelected)="existingSelected.emit({ index: i, contact: $event })"
            ></app-choose-contact>
          </p-accordion-content>
        </p-accordion-panel>
      }
    </p-accordion>
  }
</div>
